<template>
  <div class="locality-conditions">
    <div class="mt-2 condition-area">
      <button
        class="condition-button"
        :class="{ 'is-active': selectedCount }"
        @click="isOpenedLocalityFilter = true"
      >
        <span class="condition-button__text flex-grow-1">{{
          selectedLocalitiesLabel
        }}</span>
        <span
          v-if="selectedCount > 0"
          class="ml-2 text-center condition-button__count"
          >({{ selectedCount }})</span
        >
        <FeatherIcon
          icon="chevron-right"
          class="condition-button__icon"
          size="1x"
        />
      </button>
    </div>
  </div>
  <SearchModal
    v-if="isOpenedLocalityFilter"
    title="市区町村"
    @clickBack="isOpenedLocalityFilter = false"
    @save="save"
  >
    <FormCheckboxGroup
      v-model="selectedItems"
      :name="`localities-${option.prefecture.id}`"
      :options="option.localities"
    />
  </SearchModal>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import FormCheckboxGroup from "@/components/molecules/form/FormCheckboxGroup.vue";
import SearchModal from "@/components/organisms/orders/SearchModal.vue";
import { LocalityOption } from "@/types/form/LocalityOption";

@Component({
  components: {
    FeatherIcon,
    FormCheckboxGroup,
    SearchModal
  }
})
export default class LocalityConditionForm extends Vue {
  @Prop({
    type: Array,
    required: true
  })
  value!: string[];

  @Prop({
    type: Object,
    required: true
  })
  option!: LocalityOption;

  selectedItems: string[] = [];
  isOpenedLocalityFilter = false;

  @Watch("value", { immediate: true })
  onChangeValue(newValue: string[]) {
    this.selectedItems = newValue;
  }

  get selectedLocalities() {
    return this.option.localities.filter(locality =>
      this.selectedItems.includes(locality.value)
    );
  }

  get selectedCount() {
    return this.selectedLocalities.length;
  }

  get selectedLocalitiesLabel() {
    if (this.selectedCount === 0) {
      return `${this.option.prefecture.name} 全域`;
    }
    return `${this.option.prefecture.name} ${this.selectedLocalities
      .map(locality => locality.text)
      .join(", ")}`;
  }

  save() {
    this.$emit("input", this.selectedItems);
    this.isOpenedLocalityFilter = false;
  }
}
</script>

<style lang="scss" scoped>
.condition-area {
  border: 1px solid $gray-03;
  border-radius: 4px;
}

.condition-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  padding: 0 8px;
  background: $white;
  border: 1px solid $gray-03;
  border-radius: 4px;

  &__text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__icon {
    min-width: 16px;
  }

  &__count {
    min-width: 32px;
    color: $blue;
  }
}
</style>
